import { useMemo } from 'react'
import * as con from '../../GlobalConstants'
import { RefMarketValueHook } from './MarketValuesHook'
import { RefModelParameterHook } from './ModelParameterHooks'
import { daysIdToInt } from '../../GlobalFunctions'


export const DEFAULT_FORWARD_CURVE = {
    [con.DAYS]: con.FORWARD_CURVE_DAYS.map(d => daysIdToInt(d)),
    [con.BUY]: con.FORWARD_CURVE_DAYS.map(() => 0.08),
    [con.SELL]: con.FORWARD_CURVE_DAYS.map(() => 0.08),
}

export const useForwardCurve = () => {
        
    const marketForwardCurve = RefMarketValueHook(con.MARKET_FORWARD_CURVE)
    const isActiveCustomCurve = RefModelParameterHook(con.CUSTOM_FORWARD_CURVE_ACTIVE)
    const customCurve = RefModelParameterHook(con.CUSTOM_FORWARD_CURVE)

    return useMemo(() => {
        if (!marketForwardCurve || Object.keys(marketForwardCurve).length === 0)
            return DEFAULT_FORWARD_CURVE

        const automaticCurve = {
            [con.DAYS]: con.FORWARD_CURVE_DAYS.map(d => daysIdToInt(d)),
            [con.BUY]: con.FORWARD_CURVE_DAYS.map(d => marketForwardCurve[d] + con.DEVALUATION_FWD_SPREAD_BUY_SELL),
            [con.SELL]: con.FORWARD_CURVE_DAYS.map(d => marketForwardCurve[d] - con.DEVALUATION_FWD_SPREAD_BUY_SELL),
        }

        if (!isActiveCustomCurve) return automaticCurve

        if (!customCurve) return automaticCurve

        return customCurve

    }, [marketForwardCurve, isActiveCustomCurve, customCurve])
}
